import { inject, Injectable } from '@angular/core';
import { StepResolverStrategy } from './step-resolver.strategy';
import { Step } from '../../types';
import { Observable, of } from 'rxjs';
import { ConfirmationStepDefinitionService } from '../step-definition';

@Injectable({
  providedIn: 'root',
})
export class ConfirmationStepResolverService implements StepResolverStrategy {
  private readonly confirmationStepDefinitionService = inject(ConfirmationStepDefinitionService);

  resolve(): Observable<Step> {
    return of(this.confirmationStepDefinitionService.getStepDefinition());
  }
}
